module.exports = __webpack_public_path__ + "static/media/Aikido.46e9b6e0.jpg";